// Three binary facts every item has an answer to, in the same shape tarotBadges.js emits so
// BadgeRow renders both. Fixed at three slots because the compact grid gives each badge an
// equal track: a card with fewer would leave a hole in the row.
//
// canBeDestroyed and areVisitsVisible are the other two engine facts. They stay off the card
// and in the filter bar: both are true for most items, so as a fourth and fifth badge they
// would be noise on every card to flag the handful of exceptions.
const BADGES = [
    {
        meaning: 'Use',
        shortLabel: 'Use',
        test: (item) => item.isActive,
        when: { label: 'Active', icon: 'fa fa-bolt', slug: 'active', value: 'active' },
        unless: { label: 'Passive', icon: 'fa fa-leaf', slug: 'passive', value: 'passive' },
        facet: 'type',
    },
    {
        meaning: 'Uses',
        shortLabel: 'Uses',
        test: (item) => item.isConsumable,
        when: { label: 'Consumable', icon: 'fa fa-flask', slug: 'consumable', value: 'yes' },
        unless: { label: 'Permanent', icon: 'fa fa-infinity', slug: 'permanent', value: 'no' },
        facet: 'consumable',
    },
    {
        meaning: 'Transfer',
        shortLabel: 'Pass',
        test: (item) => item.canBePassed,
        when: { label: 'Passable', icon: 'fa fa-hand-paper', slug: 'passable', value: 'yes' },
        unless: { label: 'Bound', icon: 'fa fa-lock', slug: 'bound', value: 'no' },
        facet: 'passable',
    },
];

export function badgesFor(item) {
    if (!item) return [];

    return BADGES.map((badge) => {
        const state = badge.test(item) ? badge.when : badge.unless;
        return {
            label: state.label,
            meaning: badge.meaning,
            shortLabel: badge.shortLabel,
            icon: state.icon,
            slug: state.slug,
            facet: { id: badge.facet, value: state.value },
        };
    });
}

export default badgesFor;
